<template>
    <span>
        <button type="button" :class="buttonClass" :disabled="disabled || busy || proof.can_approve === false || !['draft', 'manual_image'].includes(proof.source) || proof.approved || !proof.checksums['print-source.pdf']" @click="open">
            {{ proof.approved ? 'Korr godkänt' : buttonLabel }}
        </button>
        <small v-if="proof.can_approve === false" class="d-block text-muted">Korret motsvarar inte aktuellt hälsningsunderlag. Skapa ett nytt korr för godkännande.</small>
        <small v-else-if="!['draft', 'manual_image'].includes(proof.source)" class="d-block text-muted">Skapa ett nytt korr från sparad design eller en manuellt vald hälsningsbild för godkännande och tryckfil.</small>
        <small v-else-if="!proof.checksums['print-source.pdf']" class="d-block text-muted">Äldre korr saknar låst tryckunderlag. Skapa ett nytt korr för godkännande.</small>
        <b-modal
            v-model="show" title="Granska och godkänn korr" size="xl"
            :no-close-on-backdrop="busy" :no-close-on-esc="busy" :hide-header-close="busy"
        >
            <p>Granska korret nedan och välj Godkänn korr. Tryckfilen skapas därefter från ordern.</p>
            <p class="text-muted">Godkännandet gäller denna korrversion och dess sparade tryckmått. Korret måste motsvara aktuell sparad design eller vald hälsningsbild.</p>
            <p v-if="error" class="alert alert-danger" role="alert">{{ error }}</p>
            <p v-if="busy" class="text-muted" role="status">{{ progress }}</p>
            <iframe :src="reviewedProof.url" title="Korr som ska godkännas" style="width: 100%; height: 60vh; border: 0;"></iframe>
            <template #modal-footer="{ cancel }">
                <button type="button" class="btn btn-light" :disabled="busy" @click="cancel()">Avbryt</button>
                <button type="button" class="btn btn-primary" :disabled="busy" @click="approve">Godkänn korr</button>
            </template>
        </b-modal>
    </span>
</template>
<script>
import apiClient from '@services/ApiClient';
import { productionError } from '@services/GreetingProductionApi';

export default {
    props: {
        orderId: { type: [Number, String], required: true },
        proof: { type: Object, required: true },
        revision: { type: Number, required: true },
        disabled: { type: Boolean, default: false },
        buttonLabel: { type: String, default: 'Godkänn korr' },
        buttonClass: { type: String, default: 'btn btn-primary btn-sm' },
    },
    data: () => ({
        show: false, busy: false, error: '', progress: '', openedProof: null, openedRevision: null,
    }),
    computed: {
        reviewedProof() { return this.openedProof || this.proof; },
    },
    methods: {
        open() { if (this.proof.can_approve === false) return; this.error = ''; this.openedProof = { ...this.proof }; this.openedRevision = this.revision; this.show = true; },
        async approve() {
            if (this.busy) return;
            this.busy = true; this.error = '';
            try {
                this.progress = 'Godkänner korr…';
                const { data } = await apiClient.post(`/vue/cardorders/${this.orderId}/production/files/${this.reviewedProof.id}/approve`, { revision: this.openedRevision });
                this.$emit('approved', data);
                this.show = false;
            } catch (error) {
                this.error = await productionError(error);
            } finally { this.busy = false; }
        },
    },
};
</script>
